//WellbeingDiary dataStore.js
export default {

  getAnswers(_callback) {
    console.log('getAnswers');
    if (!window.flutter_inappwebview.callHandler) { //this instantiates some methods so that on android the loading works
      window.flutter_inappwebview.callHandler = function () {
          var _callHandlerID = setTimeout(function () { });
          window.flutter_inappwebview._callHandler(arguments[0], _callHandlerID, JSON.stringify(Array.prototype.slice.call(arguments, 1)));
          return new Promise(function (resolve, reject) {
              console.log(typeof(reject)); //this line is just to avoid unused variable error
              window.flutter_inappwebview[_callHandlerID] = resolve;
          });
      };
    }
    window.flutter_inappwebview.callHandler('GET:DEMENTIA').then(function(result) {
      console.log(result);
      let res0 = atob(result);
      let res1 = JSON.parse(decodeURIComponent(res0));
      console.log(res1)
      _callback(res1);
    }).catch((error) => {
           console.log('failed' + error);
           _callback({});
         });
  },

  saveAnswers(items) {
    // console.log('saveAnswers');
    let data1 = JSON.stringify(items);
    let data2 = btoa(encodeURIComponent(data1));
    let data0 = data2;
    alert("SAVE:DEMENTIA:" + data0);
  },

  clearJsonData(jsonData) {
    for (var statements in jsonData) {
      console.log("clear json data");
      jsonData[statements].data.forEach((item) => {
        item.checked = 0;
        item.value = '';
      });
    }
  },

  updateDiary(answers, data) {
    var date = new Date();
    // let _currentTime = helper.getcurrentdate();
    for (var statements in data) {
      data[statements].data.forEach(function (item) {
        if (item.value.length > 1) {
          console.log("item below:");
          console.log(item.value);
          console.log(date);
          // console.log(_currentTime);
          if (Object.hasOwnProperty.call(answers, statements)) {
            if (Object.hasOwnProperty.call(answers[statements].data, item.id)) {
              answers[statements].data[item.id].answers.unshift({
                date: date.toJSON(),
                answer: item.value
              });
            } else {
              console.log("else1");
              answers[statements].data[item.id] = {
                title: item.title,
                answers: [
                  {
                    date: date.toJSON(),
                    answer: item.value
                  }
                ]
              }
            }
          } else {
            console.log("else2");
            answers[statements] = {
              data: {}
            };
            answers[statements].data[item.id] = {
              title: item.title,
              answers: [
                {
                  date: date.toJSON(),
                  answer: item.value
                }
              ]
            }
          }
        }
      });
    }
    this.saveAnswers(answers);
  },
}